import { render, staticRenderFns } from "./merged-record-display.vue?vue&type=template&id=60b1509e&scoped=true"
import script from "./merged-record-display.vue?vue&type=script&lang=js"
export * from "./merged-record-display.vue?vue&type=script&lang=js"
import style0 from "./merged-record-display.vue?vue&type=style&index=0&id=60b1509e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1509e",
  null
  
)

export default component.exports